import { Observable } from 'rxjs';
import { AfterInteractCommonBootstrapCSRService } from './services/after-interact-common-bootstrap.csr.service';
import { lazyService } from '@lentau/ui-kit/core/helpers/lazy-service';

export const LazyLoadAfterInteractCommonBootstrap: () => Observable<AfterInteractCommonBootstrapCSRService> = () =>
  lazyService(() =>
    import('./services/after-interact-common-bootstrap.csr.service').then(
      (m) => m.AfterInteractCommonBootstrapCSRService
    )
  );
